<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import BasePaywallModal from './BasePaywallModal.vue';

const route = useRoute();
const router = useRouter();
const currentUser = useMapGetter('getCurrentUser');
const currentAccountId = useMapGetter('getCurrentAccountId');
const isOnLumeratecCloud = useMapGetter('globalConfig/isOnLumeratecCloud');
const { t } = useI18n();

const moduleLabels = {
  ia: 'LumerAI',
  campaigns: 'Campanhas',
  tickets: 'Tickets',
  reports: 'Relatórios',
  sla: 'SLA',
  sms: 'SMS',
  alerts: 'Avisos Inteligentes',
  automations: 'Automações',
  macros: 'Macros',
  custom_roles: 'Grupos',
};

const moduleName = computed(() => route.query.module || 'este módulo');
const moduleLabel = computed(
  () => moduleLabels[moduleName.value] || moduleName.value
);
const isSuperAdmin = computed(() => currentUser.value?.type === 'SuperAdmin');

const goToModuleStore = () => {
  router.push({
    name: 'billing_settings_index',
    params: { accountId: currentAccountId.value },
    query: { tab: 'store', module: moduleName.value },
  });
};
</script>

<template>
  <div class="flex flex-col items-center justify-center w-full min-h-[28rem]">
    <div class="mb-5 text-center">
      <span class="i-lucide-lock-keyhole text-n-brand text-3xl" />
      <h1 class="mt-3 text-xl font-semibold text-n-slate-12">
        {{ moduleLabel }} {{ t('MODULE_PAYWALL.DISABLED_SUFFIX') }}
      </h1>
      <p class="mt-2 text-sm text-n-slate-11">
        {{ t('MODULE_PAYWALL.DESCRIPTION') }}
      </p>
    </div>
    <BasePaywallModal
      feature-prefix="MODULE_PAYWALL"
      i18n-key="PAYWALL"
      :is-on-lumeratec-cloud="isOnLumeratecCloud"
      :is-super-admin="isSuperAdmin"
      upgrade-to-app-store
      @upgrade="goToModuleStore"
    />
  </div>
</template>
